import { useQuery } from '@tanstack/react-query'
import { apiClient, authHeader } from '../lib/api'
import type { LaunchOfferInfo } from '@tnf-recruit/shared'
import { useAuth } from './useAuth'

/** A minute: the server caches the same answer, so asking more often gains nothing. */
const STALE_MS = 60_000

/** Whether the launch discount is still on, for pages anyone can see. */
export function useLaunchOffer(): LaunchOfferInfo | undefined {
  const { data } = useQuery({
    queryKey: ['launchOffer'],
    staleTime: STALE_MS,
    queryFn: async () => {
      const { data } = await apiClient.get('/payments/launch-offer')
      return data.data as LaunchOfferInfo
    },
  })
  return data
}

/**
 * The offer as it applies to the signed-in recruiter: `eligible` is false for
 * someone who has subscribed before or is comped, so they aren't shown a price
 * checkout won't give them.
 */
export function useMyLaunchOffer(options: {
  enabled: boolean
}): (LaunchOfferInfo & { eligible: boolean }) | undefined {
  const { getAccessToken } = useAuth()

  const { data } = useQuery({
    queryKey: ['launchOffer', 'me'],
    enabled: options.enabled,
    staleTime: STALE_MS,
    queryFn: async () => {
      const token = await getAccessToken()
      const { data } = await apiClient.get('/payments/launch-offer/me', authHeader(token))
      return data.data as LaunchOfferInfo & { eligible: boolean }
    },
  })
  return data
}
